// mbtipersonality.js — normalized + delegated “Add” buttons
(function init() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
    return;
  }

  // ------- Safe DOM helpers -------
  const $  = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  // ------- Normalization helpers -------
  function normalizePath(input){
    try {
      // accept absolute URL or path
      let p = /^https?:\/\//i.test(input) ? new URL(input, location.origin).pathname : (input || '');
      p = p.replace(/[?#].*$/,'');            // strip query/hash
      p = p.replace(/\/index\.html?$/i,'');   // drop index.html/htm
      p = p.replace(/\/+/g,'/');              // collapse slashes
      if (p.length > 1) p = p.replace(/\/$/,''); // strip trailing slash (except root)
      if (!p.startsWith('/')) p = '/' + p;    // ensure leading slash
      return p || '/';
    } catch { return (input && input[0] === '/' ? input : '/'); }
  }
  const canonicalUrl = (u) => normalizePath(u || location.pathname);

  // ------- Toast -------
  function ensureToast() {
    let t = $('#toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'toast';
      t.className = 'toast';
      t.setAttribute('role','status');
      t.setAttribute('aria-live','polite');
      t.setAttribute('aria-atomic','true');
      document.body.appendChild(t);
      const cs = getComputedStyle(t);
      if (!cs.position || cs.position === 'static') {
        t.style.cssText = 'position:fixed;bottom:16px;left:50%;transform:translateX(-50%);background:#111;color:#fff;padding:10px 14px;border-radius:10px;opacity:0;pointer-events:none;transition:opacity .2s ease;z-index:9999;';
      }
    }
    return t;
  }
  const toast = ensureToast();
  const showToast = (msg, ms=1400) => {
    toast.textContent = msg;
    toast.style.opacity = '1';
    setTimeout(() => { toast.style.opacity = '0'; }, ms);
  };

  // ------- Storage helpers -------
  const getJSON = (k, fb) => { try { return JSON.parse(localStorage.getItem(k)) ?? fb; } catch { return fb; } };
  const setJSON = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} };

  // =====================================
  // PINS (page-level)
  // =====================================
  const PINS_KEY = 'gr_pins';
  const getPins  = () => getJSON(PINS_KEY, []);
  const setPins  = (arr) => setJSON(PINS_KEY, arr);
  const isPinned = (id) => getPins().some(p => p.id === id);



  function togglePin({ id, label, url }) {
    const pins = getPins();
    const i = pins.findIndex(p => p.id === id);
    if (i === -1) {
      pins.push({ id, label, url: canonicalUrl(url), ts: Date.now() });
      setPins(pins);
      return true;
    }
    pins.splice(i,1);
    setPins(pins);
    return false;
  }

  function renderPinButton(btn, pinned) {
    btn.dataset.pinned = pinned ? 'true' : 'false';
    btn.setAttribute('aria-pressed', String(pinned));
    const span = btn.querySelector('span');
    if (span) span.textContent = pinned ? '✓ Pinned' : '📌 Pin Tool';
    else btn.textContent = pinned ? '✓ Pinned' : '📌 Pin Tool';
  }

  function bindPinButton(btn) {
    if (!btn) return;
    const id    = btn.dataset.item  || 'profile';
    const label = btn.dataset.label || document.title || 'Profile';
    const url   = canonicalUrl(btn.dataset.url || location.pathname);
    renderPinButton(btn, isPinned(id));
    btn.addEventListener('click', (e) => {
  e.preventDefault();
  const nowPinned = togglePin({ id, label, url });

  $$(`button.pin[data-item="${id}"], #pin-page, #pin-page-2, #pin-ritual`)
    .forEach(b => renderPinButton(b, nowPinned));

  showToast(nowPinned ? `Pinned: ${label}` : `Unpinned: ${label}`);
  renderPinnedQuickActions();
});

  }

  bindPinButton($('#pin-page'));
  bindPinButton($('#pin-page-2'));
  bindPinButton($('#pin-ritual'));


  // =====================================
  // PLAYBOOK “Add” buttons (normalized + delegated)
  // =====================================
  const TOOLBOX_KEY = 'gr_toolbox_v1';
  const TOOLBOX_LEG = 'gr_toolbox'; // optional mirror for older widgets

  const getToolbox = () => getJSON(TOOLBOX_KEY, []);
  const setToolbox = (arr) => setJSON(TOOLBOX_KEY, arr);

  function removeFromToolbox(handle){
  const next = getToolbox().filter(i => i.handle !== handle);
  setToolbox(next);

  // optional: also mirror-remove from legacy store
  try {
    const leg = getJSON(TOOLBOX_LEG, []);
    const nextLeg = leg.filter(i => (i.handle || i.id) !== handle);
    setJSON(TOOLBOX_LEG, nextLeg);
  } catch {}
}

  function mirrorLegacyAdd(item){
    const leg = getJSON(TOOLBOX_LEG, []);
    if (!leg.some(x => x.handle === item.handle || x.id === item.handle)) {
      leg.push({ id:item.handle, handle:item.handle, title:item.title, label:item.title, url:item.url, color:item.color||'' });
      setJSON(TOOLBOX_LEG, leg);
    }
  }

  const fwSlugify = (s) =>
    (s || '').toLowerCase()
      .replace(/[^\p{L}\p{N}]+/gu,'-')
      .replace(/^-+|-+$/g,'') || 'item';

  // stable handle: prefer normalized path; else data id; else label
// Build a stable handle from last URL segment (preferred), then id, then label
function handleFrom(btn){
  const id     = btn.dataset.toolboxItem;
  const label  = btn.dataset.toolboxLabel || btn.textContent.trim();
  const rawUrl = btn.dataset.toolboxUrl || '';

  let lastSeg = '';
  if (rawUrl && rawUrl !== '#') {
    const norm = canonicalUrl(rawUrl);
    lastSeg = norm.split('/').filter(Boolean).pop(); // take final segment only
  }

  return lastSeg || id || fwSlugify(label);
}

  function isAlreadySaved(btn){
    const handle = handleFrom(btn);
    return getToolbox().some(x => x.handle === handle);
  }

  function saveFrameworkFromButton(btn){
  const id     = btn.dataset.toolboxItem || '';
  const label  = btn.dataset.toolboxLabel || btn.textContent.trim() || 'Saved item';
  const rawUrl = btn.dataset.toolboxUrl || '';
  const url    = rawUrl ? canonicalUrl(rawUrl) : '';           // canonical path
  const color  = btn.dataset.toolboxColor || '';

  // NEW: handle = last path segment, else id, else slug(label) — NO "fw:" prefix
  const handle = (url
    ? canonicalUrl(url).split('/').filter(Boolean).pop()
    : (id || fwSlugify(label)));

  const list = getToolbox();
  if (list.some(x => x.handle === handle)) {
    return { added:false, handle, label };
  }

  const now  = Date.now();
  const item = {
    handle,
    title: label,
    url: url || canonicalUrl(location.pathname),
    color,
    sourcePage: canonicalUrl(location.pathname),
    addedAt: now,
    lastUpdated: now,
    status: 'not_started',
    appliedCount: 0,
    reviewCount: 0,
    notes: ''
  };
  list.push(item);
  setToolbox(list);
  mirrorLegacyAdd(item);
  return { added:true, handle, label };
}


  // Initial sync (marks already-added buttons)
  function syncAddButtons(){
    $$('.gr-add-to-toolbox').forEach(btn => {
      if (btn.dataset.toolboxUrl) btn.dataset.toolboxUrl = canonicalUrl(btn.dataset.toolboxUrl);
      const exists = isAlreadySaved(btn);
      btn.setAttribute('aria-pressed', String(!!exists));
      if (exists) btn.textContent = '✓ Added';
    });
  }
  syncAddButtons();

  //add buttons

  // Keep buttons in sync if another tab changes storage
  window.addEventListener('storage', (e) => {
  if (e.key === TOOLBOX_KEY || e.key === TOOLBOX_LEG) syncAddButtons();
  if (e.key === PINS_KEY) renderPinnedQuickActions();
});


  // Optional: if your page injects/re-renders sections later, keep states fresh
  const mo = new MutationObserver((muts)=>{
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) {
        // only rescan if new buttons appeared
        if ([...m.addedNodes].some(n => n.nodeType===1 && (n.matches?.('.gr-add-to-toolbox') || n.querySelector?.('.gr-add-to-toolbox')))) {
          syncAddButtons();
        }
      }
    }
  });
  mo.observe(document.body, { childList:true, subtree:true });


})();


